import { useAuth } from "./contexts/AuthContext";
import AccessDeniedPage from "./pages/AccessDeniedPage";

export const ProtectedRoute = ({
  children,
  role,
  roles,
  requireAllRoles,
  manualSwapType,
  fallback = <AccessDeniedPage/>,
  loadingComponent = <div>Loading...</div>,
}) => {
  const {
    isAuthenticated,
    loading,
    isUserInRole,
    userRoles,
    hasAnyRole,
    hasAllRoles,
    hasManualSwapAccess,
  } = useAuth();
  
  console.log('isUserInRole: ', isUserInRole, userRoles);
  console.log('isAuthenticated: ', isAuthenticated);
  if (loading) {
    return loadingComponent;
  }

  if (!isAuthenticated) {
    return fallback;
  }

  let hasAccess = true;
  console.log('hasAccess: ', hasAccess);

  if (manualSwapType) {
    hasAccess = hasManualSwapAccess(manualSwapType);
  } else if (requireAllRoles && roles) {
    hasAccess = hasAllRoles(roles);
  } else if (roles) {
    hasAccess = hasAnyRole(roles);
  } else if (role) {
    hasAccess = isUserInRole(role);
  }

  return hasAccess ? children : fallback;
};
